import { initSliders } from './modules/slider/init-slider.js';
import { initTabs } from './modules/tabs/init-tabs.js';
import { initFormValidate } from './modules/form-validate/init-form-validate.js';
import { initMenu } from './modules/menu/init-menu.js';
import { initDrop } from './modules/init-drop.js';
import { initAccordions } from './modules/accordion/init-accordion.js';
import { initMore } from './modules/init-more.js';
import { initStock } from './modules/init-stock.js';
import { initActiveBtn } from './modules/init-active-btn.js';
import { initDataTime } from './modules/init-datatime.js';
import { initPickup } from './modules/init-pickup.js';
import { initOrder } from './modules/init-order.js';
import { initSearch } from './modules/init-search.js';
import { initMessage } from './modules/init-message.js';
import { initCatalogPage } from './modules/init-catalog-page.js';
import { initElement } from './modules/init-element.js';
import { initFormFile } from './modules/init-form-file.js';
import { initTextarea } from './modules/textarea/init-textarea.js';
import AirDatepicker from 'air-datepicker';

window.addEventListener('DOMContentLoaded', () => {
  initSearch();
  initMenu();
  initFormValidate();
  initTabs();
  initAccordions();
  initSliders();
  initDrop();

  initMore();
  initStock();
  initActiveBtn();
  //initDataTime();
  initPickup();
  initOrder();
  initMessage();
  initElement();
  initCatalogPage();
  initFormFile();
  initTextarea();

  // initScrollTable();
});

document.addEventListener('initDateTime', function(event) {
  initDataTime();
});
window.AirDatepicker = AirDatepicker;
